(function () {
    console.log("✅ antrieb-main-variant.js läuft");
  // ✅ Deine HAUPTPRODUKT-Variant-IDs je Auswahl
  const variantIdByDrive = {
    E: 52771851043155,
    F: 52771851075923,
    S: 52771851108691
  };

  function collectLineItemProperties(form) {
    const props = {};
    const els = form.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]');
    els.forEach(el => {
      if (el.type === 'checkbox' && !el.checked) return;
      if (el.type === 'radio' && !el.checked) return;

      const name = el.getAttribute('name'); // properties[XYZ]
      const m = name && name.match(/^properties\[(.+)\]$/);
      if (!m) return;

      const key = m[1];
      const val = (el.value || '').trim();
      if (val !== '') props[key] = val;
    });
    return props;
  }

  function getQuantity(form) {
    const qtyInput = form.querySelector('input[name="quantity"]');
    let q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(q) || q < 1) q = 1;
    return q;
  }

  async function addToCart(id, quantity, properties) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id, quantity, properties }]
      })
    });
    if (!res.ok) throw new Error(await res.text());
  }

  function init() {
    const block = document.querySelector('[data-antrieb-addon]');
    if (!block) return;

    const formId = block.getAttribute('data-form-id');
    const form = document.getElementById(formId);
    if (!form) return;

    // Doppelt binden verhindern
    if (form.dataset.antriebBound === '1') return;
    form.dataset.antriebBound = '1';

    // Basis-Variante (für M) = aktuell ausgewählte Variant-ID im Formular
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    const baseVariantIdForM = parseInt(idInput.value, 10);

    const propInput = form.querySelector('[data-antrieb-property]');

    function setProperty(code) {
      const labelMap = {
        M: 'Manuel per Kurbel (M)',
        E: 'Elektro mit Motor und Schalter (E)',
        F: 'Elektro mit Motor und Funkfernbedienung (F)',
        S: 'Solar mit Motor und Funkfernbedienung (S)'
      };
      if (propInput) propInput.value = labelMap[code] || code;
    }

    form.addEventListener('submit', async function (event) {
      // ✅ Wir übernehmen Add-to-cart komplett, damit definitiv die richtige Variante im Warenkorb landet
      event.preventDefault();

      const choice = form.querySelector('input[name="properties[Antrieb]"]:checked');
      if (!choice) {
        alert('Bitte Antrieb auswählen.');
        return;
      }

      const raw = (choice.value || '').trim();
const match = raw.match(/\(([MEFS])\)/);   // sucht (M) (E) (F) (S)
const code = match ? match[1] : raw;       // falls value nur "E" ist, bleibt es "E"
      setProperty(code);

      const qty = getQuantity(form);
      const properties = collectLineItemProperties(form);

      // Ziel-Variante bestimmen
      let targetVariantId = baseVariantIdForM;
      if (code !== 'M') {
        targetVariantId = variantIdByDrive[code];
        if (!targetVariantId) {
          alert('Variant-ID für diese Auswahl fehlt.');
          return;
        }
      }

      try {
        await addToCart(targetVariantId, qty, properties);
        window.location.href = '/cart';
      } catch (e) {
        console.error(e);
        alert('Konnte nicht in den Warenkorb legen. Bitte prüfe die Varianten/Verfügbarkeit.');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
